import {BBModel} from "../../bb_model";
import {Set} from "./set";

class ResourceSet extends Set {

    constructor(company) {
        super(BBModel.Admin.Resource, company);
    }

    getResource(company, id) {
        return new Promise((resolve, reject) => {
            return company.$get('resources', {embed: 'immediate_schedule'})
                .then(resources => resources.$get('resource', {id}))
                .then((resource) => {
                    const url = resource.$link('self').href;
                    if (this.set[url]) {
                        resolve(this.set[url]);
                    } else {
                        const model = new BBModel.Admin.Resource(resource);
                        this.addItem(model);
                        resolve(model);
                    }
                }, reject);
        });
    }

    $query(company) {
        const params = {};
        params.embed = 'immediate_schedule';
        return super.$query(BBModel.Admin.Resource, company, params);
    }

    static $query(company) {
        return company.resources.$query(company);
    }

    static $getResource(company, id) {
        return this.$query(company).then((set) => {
            return set.getResource(company, id);
        });
    }

}

ResourceSet.group = 'resources';
ResourceSet.model = 'resource';
ResourceSet.all = {};

export {
    ResourceSet
}

